import axios from './axios'
import qs from "qs";

function service() {

    function categorized(data = {}) {
        return axios.get('billables/categorized', { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    return {
        categorized
    }
}

export default service
